import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { notification } from "../../../utils/Notifications";
import { getLots } from "../../../api/lotsApi";
import { assignLotsToDeliveryMan } from "../../../api/lotsApi";
import useLogout from '../../../hooks/auth/authHook.js';

import {
  Button,
  Container,
  Dialog,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import styles from "./lotsAssignUserDialogStyles.js";
import { usePermissions } from "../../../hooks/permissions/usePermissions.js";

LotsAssingUserDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  deliverers: PropTypes.array,
  fetchCollectedLots: PropTypes.func,
};

export default function LotsAssingUserDialog({
  setLots,
  onClose,
  open,
  selectedLots,
  deliverers = [],
  fetchCollectedLots,
}) {
  const [logout] = useLogout();

  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { hasAllPermissions } = usePermissions();

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleAssingUserLotAdminClick = () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    assignLotsToDeliveryMan(selectedValue, selectedLots)
      .then((response) => {

        if (response.data.status_Code === 200) {
          notification({ text: "Lotes asignados", type: "success" });

          getLots()
          .then((response) => {
            if (response.status === 200) {
              setLots(response.data.collect_batch);
            } else if (response.status === 401) {
              notification({
                text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
                type: "error",
              });
              logout();
            } else {
              notification({
                text: "Error al obtener los lotes",
                type: "error",
              });
            }
          })
          .catch(() => {
            notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
          });

          // Actualizar la lista de lotes recolectados
          if (fetchCollectedLots) {
            fetchCollectedLots();
          }

          clearFields();
          setIsLoading(false);
          onClose();
        } else if (response.data.status_Code === 401) {
          notification({
            text: "Sesión expirada. Por favor, inicia sesión nuevamente.",
            type: "error",
          });
          logout();
          clearFields();
          setIsLoading(false);
        } else {
          notification({
            text: "Error al asignar los lotes",
            type: "error",
          });
          clearFields();
          setIsLoading(false);
        }
        onClose();
      })
      .catch(() => {
        notification({text: 'Error de conexión, revisa tu conexión a internet', type: 'error'});
      })
      .finally(() => {
        clearFields();
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (open) {
      clearFields();
    }
  }, [open]);

  const handleDialogClose = (event, reason) => {
    clearFields();
    if (reason === "backdropClick") {
      return;
    }
    onClose();
  };

  const clearFields = () => {
    setSelectedValue("");
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={open}
      PaperProps={{ style: styles.dialog }}
    >
      <Container style={styles.mainContainer}>
        <Typography
          component="div"
          variant="h5"
          style={styles.title}
        >
          Selecciona al repartidor
        </Typography>
        <Typography
          component="div"
          variant="body1"
          style={styles.subtitle}
        >
          Los lotes serán asignados de manera automática
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="demo-simple-select-label">Repartidor</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedValue}
                label="Repartidor"
                onChange={handleChange}
              >
                {deliverers?.map((deliveryMan) => {
                  return (
                    <MenuItem
                      key={deliveryMan.id_user}
                      value={deliveryMan.id_user}
                    >
                      {deliveryMan.name_complete}{" "}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Container
          style={styles.buttonsContainer}
        >
          <Button
            variant="standard"
            color="primary"
            onClick={() => {
              onClose();
            }}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            disabled={!selectedValue}
            onClick={() => {
              handleAssingUserLotAdminClick();
            }}
            sx={selectedValue ? styles.activeButton : styles.inactiveButton}
          >
            {isLoading ? (
              <CircularProgress size={24} style={styles.circularProgress} />
            ) : (
              "Asignar"
            )}
          </Button>
        </Container>
      </Container>
    </Dialog>
  );
}
